module.exports = __webpack_public_path__ + "static/media/deliver.e11a6d52.svg";